import httpService from "../httpService";

export default {
  findAllByHcCaseMasterId(hcCaseMasterId) {
    return httpService.get("/hcCasePhongHopUser/findAllByHcCaseMasterId", {
      params: { hcCaseMasterId }
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/phonghop/hcCasePhongHopUserService.js